<div class="country-summary">
    <div *ngIf="country; else noCountry">
        <div class="country-summary-header">
            <h4>{{ country.countryName }}</h4>
            <span class="country-status" [class.country-status-restricted]="!country.isAccessible">{{ accessibilityLabel
                }}</span>
        </div>
        <div class="country-summary-grid">
            <div>
                <strong>Region ID</strong>
                <div>{{ country.eicRegionId }}</div>
            </div>
            <div>
                <strong>Country ID</strong>
                <div>{{ country.eicCountryId }}</div>
            </div>
            <div>
                <strong>Map SID</strong>
                <div>{{ country.sid || '—' }}</div>
            </div>
            <div>
                <strong>Projects</strong>
                <div>{{ country.projectCount }}</div>
            </div>
            <div>
                <strong>Total Capex</strong>
                <div>{{ country.capex | number: '1.0-0' }}</div>
            </div>
            <div>
                <strong>Avg Capex / Project</strong>
                <div>{{ averageCapexPerProject | number: '1.0-0' }}</div>
            </div>
        </div>
    </div>
    <ng-template #noCountry>
        <div>Select a country to view its summary.</div>
    </ng-template>
</div>